var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('datepicker',{attrs:{"disabled":_vm.sending,"required":_vm.required,"value":_vm.dateValue,"format":_vm.format,"clear-button":_vm.clearButton,"language":_vm.lang,"disabled-dates":_vm.invalidDates,"use-utc":false},on:{"input":_vm.inputDatetime}},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }